/** Which backtest run the Backtest room shows. Set by "Open in Backtest". */

import { Atom } from '../../state/atom.ts';
import { getArgusBacktestQueue } from '../../api/endpoints.ts';

export const backtestSelected = new Atom<string | null>(null);

/** How many backtests wait and run now, read before someone asks for one. */
export const backtestQueue = new Atom<{ queued: number; running: number } | null>(null);
let readAt = 0;

/** Read the queue again, at most every few seconds: on show, hover, ask and finish. */
export async function refreshBacktestQueue(): Promise<void> {
  if (Date.now() - readAt < 3000) return;
  readAt = Date.now();
  try {
    backtestQueue.set(await getArgusBacktestQueue());
  } catch {
    // The line is a courtesy; without it the button still works.
  }
}

/** One line for under a Backtest button, or '' while the watchers are free. */
export function queueWords(q: { queued: number; running: number } | null): string {
  if (!q || (!q.queued && !q.running)) return '';
  const parts = [q.running ? `${q.running} running` : '', q.queued ? `${q.queued} waiting` : ''].filter(Boolean);
  return `Watchers busy: ${parts.join(', ')}. Yours joins the queue and can take a few minutes.`;
}

/** The progress line of a run that waits. */
export function waitingWords(ahead: number | null | undefined): string {
  return ahead ? `Waiting - ${ahead} ahead of yours` : 'Waiting for the watcher';
}
